import React from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../shared/EmptyState';
import './RecentTestRuns.css';

interface RunRow {
  id: string;
  name: string;
  status: string;
  project_name: string | null;
  total_cases: number;
  pass_count: number;
  fail_count: number;
  blocked_count: number;
  pass_percentage: number;
  duration_seconds: number | null;
}

interface Props {
  runs: RunRow[];
  loading: boolean;
}

const statusBadge = (status: string) => {
  if (status === 'COMPLETED') return <span className="rtr-badge rtr-completed">COMPLETED</span>;
  if (status === 'IN_PROGRESS') return <span className="rtr-badge rtr-inprogress">IN PROGRESS</span>;
  if (status === 'ABORTED') return <span className="rtr-badge rtr-aborted">ABORTED</span>;
  return <span className="rtr-badge rtr-notstarted">NOT STARTED</span>;
};

export const RecentTestRuns: React.FC<Props> = ({ runs, loading }) => (
  <div className="rtr-card">
    <div className="rtr-header">
      <h3>Recent Test Runs</h3>
      <Link to="/test-runs" className="rtr-view-all">View All Test Runs →</Link>
    </div>
    {loading ? (
      <div className="rtr-skeleton" />
    ) : runs.length === 0 ? (
      <EmptyState message="No test runs yet." actionLabel="Create your first test run" actionLink="/test-runs/create" />
    ) : (
      <div className="rtr-table-wrap">
        <table className="rtr-table">
          <thead>
            <tr>
              <th>Test Run</th>
              <th>Project</th>
              <th>Total</th>
              <th>Passed</th>
              <th>Failed</th>
              <th>Blocked</th>
              <th>Pass %</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {runs.map(run => (
              <tr key={run.id}>
                <td><Link to={`/test-runs/${run.id}`} className="rtr-name">{run.name}</Link></td>
                <td className="rtr-muted">{run.project_name || '—'}</td>
                <td>{run.total_cases}</td>
                <td className="rtr-pass">{run.pass_count}</td>
                <td className="rtr-fail">{run.fail_count}</td>
                <td className="rtr-blocked">{run.blocked_count}</td>
                <td className={run.pass_percentage < 80 ? 'rtr-fail' : 'rtr-pass'}>
                  {run.pass_percentage != null ? `${run.pass_percentage}%` : '—'}
                </td>
                <td>{statusBadge(run.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default RecentTestRuns;
